const INIT_STATE = {
   actionId: null,
   mailBoxId: null,
   detailsMessage: null,
   comment: "",
   stepId: null,
   selectedRecipient: null,
   listOfAllUsers: [],
   allUsersLoading: false,
   allUsersLoaded: false,
   allUsersError: null,
   folderCache: {},
   showReturnButton: true,
   isMailboxAdded: false,
   mailBoxes: [],
};

export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "GET_ACTION_ID": {
         return { ...state, actionId: action.payload };
      }
      case "GET_COMMENT": {
         return { ...state, comment: action.payload };
      }
      case "GET_SELECTED_RECIPIENT": {
         return { ...state, selectedRecipient: action.payload };
      }
      case "GET_STEP_ID": {
         return { ...state, stepId: action.payload };
      }
      case "GET_MAILBOX_ID": {
         return { ...state, mailBoxId: action.payload };
      }
      case "SET_PROCESS_MESSAGE": {
         return { ...state, detailsMessage: action.message };
      }
      case "FETCH_ALL_USERS_REQUEST": {
         return { ...state, allUsersLoading: true, allUsersError: null };
      }
      case "FETCH_ALL_USERS_FAILURE": {
         return {
            ...state,
            allUsersLoading: false,
            allUsersError: action.payload,
            allUsersLoaded: false,
         };
      }
      case "SET_ALL_USERS_LIST": {
         return {
            ...state,
            listOfAllUsers: action.payload,
            allUsersLoading: false,
            allUsersLoaded: true,
            allUsersError: null,
         };
      }
      case "SET_FOLDER_CACHE": {
         return { ...state, folderCache: action.payload };
      }
      case "SET_SHOW_RETURN_BUTTON": {
         return { ...state, showReturnButton: action.payload };
      }
      case "SET_USER_MAILBOXES": {
         return { ...state, mailBoxes: action.payload };
      }
      case "SET_IS_MAILBOX_ADDED": {
         return { ...state, isMailboxAdded: action.payload };
      }
      default:
         return state;
   }
};
